import { BarCodeScanner } from "expo-barcode-scanner";
import { Text } from "native-base";
import React, { useEffect, useRef, useState } from "react";
import {
	Dimensions,
	SafeAreaView,
	StatusBar,
	StyleSheet,
	View,
} from "react-native";
// Components.
import FooterButton from "./FooterButton";
import MaskRound from "./MaskRound";

function Hint({ children }) {
	return <Text style={styles.headerText}>{children}</Text>;
}

const { width, height } = Dimensions.get("window");
const RATIO = "4:3";

const AppScanCamera = ({
	onCapture,
	onCancelPress,
	onClose,
	base64 = false,
	datatype_name = "",
}) => {
	const [scanned, setScanned] = useState(false);
	const [isLit, setLit] = useState(false);
	const [pictureSize, setPictureSize] = useState(undefined);
	const [pictureSizes, setPictureSizes] = useState([]);
	const [pictureSizeId, setPictureSizeId] = useState(0);
	const [hasPermission, setHasPermission] = useState(null);

	const cameraRef = useRef(null);

	useEffect(() => {
		(async () => {
			const { status } = await BarCodeScanner.requestPermissionsAsync();
			setHasPermission(status === "granted");
		})();
	}, []);

	const onCapturePress = async ({ type, data }) => {
		return onCapture(data, datatype_name);
	};

	if (hasPermission === null) {
		return <View />;
	}

	return (
		<SafeAreaView style={styles.container}>
			<BarCodeScanner
				ref={cameraRef}
				focusable={true}
				onBarCodeScanned={onCapturePress}
				style={StyleSheet.absoluteFillObject}
				style={{ width: width, height: height / 1.05 }}
			/>

			<View style={[styles.header, { top: 10 }]}>
				{/* <Hint>Capture the ID/Passport</Hint> */}
				<FooterButton
					onPress={() => onClose()}
					iconName="ios-close"
					iconSize={48}
				/>
			</View>

			<View style={[styles.footer]}>
				<MaskRound />
			</View>
			<StatusBar barStyle="light-content" backgroundColor="#000" />
		</SafeAreaView>
	);
};

const styles = StyleSheet.create({
	container: {
		flex: 1,
		// backgroundColor: "#fff",
		justifyContent: "center",
		alignItems: "center",
	},
	hint: {
		paddingHorizontal: 16,
		paddingVertical: 20,
		borderRadius: 16,
		justifyContent: "center",
		alignItems: "center",
	},
	header: {
		position: "absolute",
		// left: 0,
		right: 0,
		alignItems: "center",
		flexDirection: "row",
		justifyContent: "space-between",
		paddingHorizontal: 8,
	},
	headerText: {
		color: "#000",
		backgroundColor: "transparent",
		textAlign: "center",
		fontSize: 18,
		fontWeight: "700",
	},
	footer: {
		position: "absolute",
		left: 0,
		right: 0,
		alignItems: "center",
		flexDirection: "row",
		justifyContent: "space-between",
		paddingHorizontal: "10%",
	},
});

export default AppScanCamera;
